import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { VirtualEventStatus, Frequency } from "generated-graphql/graphql";

export const virtualEventStatusToLabel = (
  status: VirtualEventStatus | string
) => {
  switch (status) {
    case VirtualEventStatus.Active:
      return "Open";
    default:
      return prettyPrintEnumValue(status);
  }
};

export const getFrequencyLabel = (frequency: Frequency) => {
  switch (frequency) {
    case Frequency.Weekly:
      return "week";
    case Frequency.Monthly:
      return "month";
    case Frequency.Quarterly:
      return "quarter";
    case Frequency.Yearly:
      return "year";
    default:
      return "";
  }
};
